export default "<!-- Header -->\r\n<header>\r\n  <h3 class=\"title-screen-ui\">{{title}}</h3>\r\n</header>\r\n<main></main>\r\n";